import { ResponsiveContainer, AreaChart, Area, Tooltip } from "recharts";
import { useT } from "../../contexts/LanguageContext";

function Sparkline({ data, label, color = "#002FA7" }) {
  const latest = data.length ? data[data.length - 1].score : 0;
  const prev = data.length > 1 ? data[data.length - 2].score : latest;
  const delta = Math.round((latest - prev) * 10) / 10;
  const trend = delta > 0 ? "↑" : delta < 0 ? "↓" : "·";
  const trendColor = delta > 0 ? "text-[#059669]" : delta < 0 ? "text-[#E11D48]" : "text-slate-400";
  return (
    <div className="flex-1 min-w-0" data-testid={`sparkline-${label}`}>
      <div className="flex items-baseline justify-between">
        <div className="text-sm font-semibold truncate">{label}</div>
        <div className={`text-xs font-mono font-bold ${trendColor}`}>
          {latest.toFixed(0)}% <span className="ml-0.5">{trend}{Math.abs(delta) || ""}</span>
        </div>
      </div>
      <div className="h-12 mt-1">
        {data.length >= 2 ? (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
              <defs>
                <linearGradient id={`spark-${label}`} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={color} stopOpacity={0.35} />
                  <stop offset="100%" stopColor={color} stopOpacity={0} />
                </linearGradient>
              </defs>
              <Tooltip
                cursor={false}
                contentStyle={{ background: "#0F172A", border: "none", borderRadius: 6, color: "#fff", fontSize: 11, padding: "4px 8px" }}
                formatter={(v) => [`${v}%`, label]}
                labelFormatter={(l) => l}
              />
              <Area type="monotone" dataKey="score" stroke={color} strokeWidth={2} fill={`url(#spark-${label})`} />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-full grid place-items-center text-[10px] text-slate-400">—</div>
        )}
      </div>
    </div>
  );
}

export default function DomainSparklines({ data }) {
  const { t, tDomain } = useT();
  const domains = ["People", "Process", "Business Environment"];
  const colors = ["#002FA7", "#D97706", "#059669"];
  return (
    <div className="card lg:col-span-4" data-testid="domain-sparklines">
      <div className="overline">{t("analytics.spark_overline")}</div>
      <h3 className="font-display text-xl font-semibold mt-1">{t("analytics.spark_title")}</h3>
      <div className="mt-4 space-y-3">
        {domains.map((d, i) => (
          <Sparkline key={d} label={tDomain(d)} data={(data && data[d]) || []} color={colors[i]} />
        ))}
      </div>
    </div>
  );
}
